module.exports = __webpack_public_path__ + "img/sz-ynjd-banner.30d6442f.jpg";